(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accessories-editorial-template"]) return;
  try {
    
var loadInstagramPictures = function() {
    var instagramImagesSection = document.querySelector(".editorial__instagram-block__images");
    if (instagramImagesSection === null) { return; }

    var requestUrl = "https://os-heimdall-production.herokuapp.com/api/v1/instagram/me/images";

    var request = new XMLHttpRequest();
    request.open("GET", requestUrl);
    request.onload = function() {
      if (request.status >= 200 && request.status < 300) {
        const image_urls = JSON.parse(request.response);
        const image_divs = image_urls.slice(0, 4).map(function(url) {
          return `<div class="grid__item medium-up--one-quarter small--one-half editorial__instagram-block__image"><div class="editorial__instagram-block__image--background" style="background-image: url(${url});"></div></div>`;
        });
        instagramImagesSection.innerHTML = image_divs.join('');
      }
    };
    request.send();
};

loadInstagramPictures();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kalksten-editorial-template"]) return;
  try {
    
var loadInstagramPictures = function() {
    var instagramImagesSection = document.querySelector(".editorial__instagram-block__images");
    if (instagramImagesSection === null) { return; }

    var requestUrl = "https://os-heimdall-production.herokuapp.com/api/v1/instagram/me/images";

    var request = new XMLHttpRequest();
    request.open("GET", requestUrl);
    request.onload = function() {
      if (request.status >= 200 && request.status < 300) {
        const image_urls = JSON.parse(request.response);
        const image_divs = image_urls.slice(0, 4).map(function(url) {
          return `<div class="grid__item medium-up--one-quarter small--one-half editorial__instagram-block__image"><div class="editorial__instagram-block__image--background" style="background-image: url(${url});"></div></div>`;
        });
        instagramImagesSection.innerHTML = image_divs.join('');
      }
    };
    request.send();
};

loadInstagramPictures();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marmor-editorial-template"]) return;
  try {
    
var loadInstagramPictures = function() {
    var instagramImagesSection = document.querySelector(".editorial__instagram-block__images");
    if (instagramImagesSection === null) { return; }

    var requestUrl = "https://os-heimdall-production.herokuapp.com/api/v1/instagram/me/images";

    var request = new XMLHttpRequest();
    request.open("GET", requestUrl);
    request.onload = function() {
      if (request.status >= 200 && request.status < 300) {
        const image_urls = JSON.parse(request.response);
        const image_divs = image_urls.slice(0, 4).map(function(url) {
          return `<div class="grid__item medium-up--one-quarter small--one-half editorial__instagram-block__image"><div class="editorial__instagram-block__image--background" style="background-image: url(${url});"></div></div>`;
        });
        instagramImagesSection.innerHTML = image_divs.join('');
      }
    };
    request.send();
};

loadInstagramPictures();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
    // Look for an element with class 'product-recommendations'
    var productRecommendationsSection = document.querySelector(".product-recommendations");
    if (productRecommendationsSection === null) { return; }
    // Read product id from data attribute
    var productId = productRecommendationsSection.dataset.productId;
    // Read base URL from data attribute
    var baseUrl = productRecommendationsSection.dataset.baseUrl;
    // Read limit from data attribute
    var limit = productRecommendationsSection.dataset.limit;
    // Build request URL
    var requestUrl = baseUrl + "?section_id=product-recommendations&product_id=" + productId + "&limit=" + limit;
    // Create request and submit it using Ajax
    var request = new XMLHttpRequest();
    request.open("GET", requestUrl);
    request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
        var container = document.createElement("div");
        container.innerHTML = request.response;
        productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
    }
    };
    request.send();
};

// Listen for changes done in the Theme Editor
document.addEventListener("shopify:section:load", function(event) {
    if (event.detail.sectionId === "product-recommendations") {
    loadProductRecommendationsIntoSection();
    }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
